import { type ReactNode, type ReactElement } from 'react'
import * as styles from './Sidebar.css'
import { Stack } from '@christiankaindl/lyts'
import { Info, MoreHorizontalIcon } from 'lucide-react'
import Button from '@/components/Button/Button'
import SearchButton from './SearchButton'
import { infoOverlayStore } from '@/components/Norm/Utils'
import { Menu, MenuButton } from '@/components/Menu'
import { ActionRow, Header } from './Sidebar.client'

interface SidebarContentProps {
  title: string
  menu?: ReactNode
  children: ReactElement<any>
  forceShowTitle?: boolean
  onSelect?: () => void
  showSearch?: boolean
  normId: string // TODO: Replace with norm context provider
  abbrNr?: number // TODO: Replace with norm context provider
  headerClassName?: string
  headerButtons?: ReactNode
  noToc?: boolean
  abbreviation?: string
  content?: ReactElement<any>
}
export default function SidebarContent ({ title, menu, children, forceShowTitle = false, showSearch = false, headerClassName, headerButtons, noToc = false, abbreviation, content }: SidebarContentProps) {
  return (
    <Stack gap={1.5} className={styles.content}>
      <Header forceShowTitle={forceShowTitle} title={title} abbreviation={abbreviation} className={headerClassName} >
        <ActionRow menu={menu} showSearch={showSearch} headerButtons={headerButtons} noToc={noToc} />
      </Header>
      <Stack gap='6px' style={{ paddingLeft: 9, marginTop: -18 }}>
        {headerButtons}
        {showSearch && <SearchButton size='medium' />}
        {!noToc && <Button variant='flat' icon={Info} onClick={() => { infoOverlayStore.set({ isOpen: true }) }} style={{ gap: '0.8rem' }}>Info</Button>}
        <Menu>
          <MenuButton variant='flat' title='Optionen' style={{ gap: '0.8rem' }}>
            <MoreHorizontalIcon size={20} />
            Mehr
          </MenuButton>
          {menu}
        </Menu>
      </Stack>
      {content}
      {children}
    </Stack>
  )
}
